import { render, staticRenderFns } from "./ServiceCategory.vue?vue&type=template&id=93caec0a&scoped=true&"
import script from "./ServiceCategory.vue?vue&type=script&lang=js&"
export * from "./ServiceCategory.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCategory.vue?vue&type=style&index=0&id=93caec0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93caec0a",
  null
  
)

export default component.exports